import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import { Navigate, Outlet, createBrowserRouter } from'react-router-dom';
import WidgetDynamicLoading from './widgets/WidgetDynamicLoading';
import BookNowForm from './widgets/horecaWidget/BooknowForm';
import { Provider } from 'react-redux'
import { store,persistor } from './store/Store';
import Paymentfailure from './widgets/horecaWidget/Paymentfailure';
import PaymentPending from './widgets/horecaWidget/PaymentPending';
import { Suspense, useEffect } from 'react';
import { useTranslation} from 'react-i18next';
import SuccessScreen from './widgets/feedbackWidget/SuccessScreen';
import OpeningHoursCalendar from './widgets/openingHours/OpeningHours';
import ReservationCancelResponse from './widgets/horecaWidget/ReservationCancelResponse';
import BookNowFormTicket from './widgets/ticketingWidget/BookNowFormTicket';
import BookNowActivities from './widgets/ActivitiesWidget/BookNowActivities';
import PaymentSuccessActivity from './widgets/ActivitiesWidget/PaymentSuccessActivity';
import ThemeProviderWrapper from './theme';
import ConditionalRedirect from './widgets/horecaWidget/ConndtionalRedirect';

const hasValidQueryParams = (search) => {
  const params = new URLSearchParams(search);
  const widgetSetupId = params.get("widgetsetupid");
  const key = params.get("key");
  const resType = params.get("resType");
  return widgetSetupId && key && resType; // Check if all required parameters exist
};

const WidgetWrapper = () => {
  // Here we can extract the search from window location
  const search = window.location.search;

  return hasValidQueryParams(search) ? <WidgetDynamicLoading /> : <Navigate to="/" />;
};
export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Provider store={store}>
        <ThemeProviderWrapper> {/* Use the ThemeProviderWrapper here */}
          <App />
          </ThemeProviderWrapper>
        </Provider>
      </Suspense>
    ),

    children: [
      {
        path: "/",
        element: <ConditionalRedirect />, // Redirect to base path
      },
      {
        path: "widget",
        element: <WidgetWrapper />, // Use the wrapper component to check for query params
        children: [
    
        
        ],
      },
      {
        path: "/successFeedback",
        element: <SuccessScreen />,
      },
      {
        path:`/`,
        element: <PaymentSuccessActivity />,
      },
      {
        path: "/ReservationCancelSuccess",
        element: <ReservationCancelResponse />,
      },
   
      {
        path: "/openingHours/:key",
        element: <OpeningHoursCalendar />,
      },
      {
        path: "/bookNow",
        element: <BookNowForm />,
      },
      {
        path: "bookNowTickets",
        element: <BookNowFormTicket />,
      },
      {
        path: "bookNowActivity",
        element: <BookNowActivities />,
      },
      {
        path: "paymentStatusfail",
        element: <Paymentfailure />,
      },
      {
        path: "paymentpending",
        element: <PaymentPending />,
      },
    ],
  },
]);
function App() {

  const { t, i18n } = useTranslation();
  
  return (
    <>
    <CssBaseline />
    <Outlet />
  </>
  );
}

export default App;
